/**
 * Trouver un revendeur (template trouver-un-revendeur.php)
 *
 * Carte Google Maps, liste des revendeurs et recherche par adresse ou par
 * géolocalisation. La liste est rendue par le serveur : ce script la lit, la
 * trie et la filtre. Marqueurs, regroupements et infobulle sont dessinés en
 * HTML sur la carte (OverlayView), pour suivre la maquette.
 *
 * Écrit en ES5 : la chaîne de build (uglify-js 3.4) ne lit pas l'ES2015.
 */
(function($, window, document) {
	'use strict';

	var MAPS_CALLBACK = 'azurlignResellersMapsReady';
	var CLUSTER_DISTANCE = 44; // px : deux marqueurs plus proches sont regroupés
	var SAME_PLACE = 0.0002; // degrés (~20 m) : un regroupement qu'aucun zoom ne séparera
	var FOCUS_ZOOM = 14;
	var MAX_FIT_ZOOM = 14;
	var REGIONS = ['fr', 'be'];

	var PIN_SVG = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path fill="#fff" d="M12 2a8 8 0 0 0-8 8c0 6.5 8 12 8 12s8-5.5 8-12a8 8 0 0 0-8-8z"/><circle cx="12" cy="10" r="3" fill="currentColor"/></svg>';
	var CLOSE_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';

	function ResellersFinder($root) {
		var self = this;

		self.$root = $root;
		self.$form = $root.find('[data-resellers-search]');
		self.$input = $root.find('[data-resellers-input]');
		self.$suggestions = $root.find('[data-resellers-suggestions]');
		self.$locate = $root.find('[data-resellers-locate]');
		self.$status = $root.find('[data-resellers-status]');
		self.$list = $root.find('[data-resellers-list]');
		self.mapEl = $root.find('[data-resellers-map]')[0];

		var fallback = parseInt($root.attr('data-fallback'), 10);
		self.settings = {
			radius: parseFloat($root.attr('data-radius')) || 50,
			fallback: isNaN(fallback) ? 5 : fallback,
			mapsKey: $root.attr('data-maps-key') || '',
		};

		self.resellers = [];
		self.byId = {};
		self.$list.find('[data-reseller]').each(function() {
			var $item = $(this);
			var reseller = {
				id: $item.attr('data-id'),
				lat: parseFloat($item.attr('data-lat')),
				lng: parseFloat($item.attr('data-lng')),
				$item: $item,
				text: normalize($item.text()),
			};
			self.resellers.push(reseller);
			self.byId[reseller.id] = reseller;
		});

		self.maps = null;
		self.map = null;
		self.layer = null;
		self.popup = null;
		self.position = null;
		self.activeId = null;
		self.suggest = { items: [], active: -1, token: null, request: 0, enabled: false, timer: null };

		self.bindSearch();
		self.bindList();

		loadMaps(self.settings.mapsKey).then(
			function(maps) {
				self.initMap(maps);
			},
			function() {
				self.mapUnavailable();
			}
		);
	}

	ResellersFinder.prototype = {
		/* ================================
		 * Carte
		 * ================================ */
		initMap: function(maps) {
			var self = this;

			self.maps = maps;
			self.resellers.forEach(function(reseller) {
				reseller.latLng = new maps.LatLng(reseller.lat, reseller.lng);
			});

			self.map = new maps.Map(self.mapEl, {
				center: { lat: 46.6, lng: 2.4 },
				zoom: 5,
				minZoom: 4,
				maxZoom: 18,
				disableDefaultUI: true,
				zoomControl: true,
				gestureHandling: 'cooperative',
				clickableIcons: false,
			});

			self.layer = createMarkersLayer(maps, self);
			self.layer.setMap(self.map);
			// Filet de sécurité : la carte arrêtée, l'échelle des regroupements est forcément la bonne
			self.map.addListener('idle', function() {
				self.layer.draw();
			});
			self.popup = createHtmlOverlay(maps, 'resellers-popup', 'floatPane');
			self.position = createHtmlOverlay(maps, 'resellers-position', 'overlayLayer');

			self.map.addListener('click', function() {
				self.closePopup();
			});

			self.suggest.enabled = !!(maps.places && maps.places.AutocompleteSuggestion);
			self.$root.addClass('is-map-ready');
			self.fitTo(self.resellers);
		},

		mapUnavailable: function() {
			this.map = null;
			this.$root.addClass('is-map-unavailable');
			$(this.mapEl).html('<p class="resellers__map-message">La carte ne peut pas s\'afficher pour le moment. La liste des revendeurs reste disponible.</p>');
		},

		/**
		 * Cadre la carte sur des revendeurs, et sur le point recherché s'il y en a un
		 */
		fitTo: function(resellers, point) {
			var self = this;
			if (!self.map) return;

			if (!resellers.length) {
				if (point) {
					self.map.setCenter(point);
					self.map.setZoom(9);
				}
				return;
			}

			var bounds = new self.maps.LatLngBounds();
			resellers.forEach(function(reseller) {
				bounds.extend(reseller.latLng);
			});
			if (point) bounds.extend(point);

			self.map.fitBounds(bounds, 40);
			self.maps.event.addListenerOnce(self.map, 'idle', function() {
				if (self.map.getZoom() > MAX_FIT_ZOOM) self.map.setZoom(MAX_FIT_ZOOM);
			});
		},

		onGroupClick: function(group) {
			if (group.resellers.length === 1) {
				this.select(group.resellers[0], { scrollList: true });
				return;
			}

			var bounds = new this.maps.LatLngBounds();
			group.resellers.forEach(function(reseller) {
				bounds.extend(reseller.latLng);
			});
			var span = bounds.toSpan();
			var inseparable = span.lat() < SAME_PLACE && span.lng() < SAME_PLACE;

			if (inseparable || this.map.getZoom() >= this.map.get('maxZoom')) {
				this.setActive(null);
				this.openPopup(group.resellers, group.latLng);
			} else {
				this.closePopup();
				this.map.fitBounds(bounds, 60);
			}
		},

		/**
		 * Affiche un revendeur : infobulle sur la carte et mise en avant dans la liste
		 */
		select: function(reseller, options) {
			options = options || {};
			this.setActive(reseller.id, options.scrollList);

			if (!this.map) return;

			var moving = false;
			if (options.fromList) {
				// Il peut être caché dans un regroupement : on zoome dessus
				var zoomIn = this.map.getZoom() < FOCUS_ZOOM;
				moving = zoomIn || !this.map.getCenter().equals(reseller.latLng);
				if (zoomIn) this.map.setZoom(FOCUS_ZOOM);
				this.map.panTo(reseller.latLng);
				this.bringMapIntoView();
			}

			this.openPopup([reseller], reseller.latLng, moving);
		},

		setActive: function(id, scrollList) {
			this.activeId = id;
			this.$list.find('.resellers-item.is-active').removeClass('is-active');

			if (id && this.byId[id]) {
				var $item = this.byId[id].$item.addClass('is-active');
				if (scrollList) this.scrollListTo($item);
			}

			if (this.layer) this.layer.markActive();
		},

		/**
		 * @param {Array}   resellers  Un revendeur, ou plusieurs au même endroit
		 * @param {LatLng}  latLng     Point d'ancrage
		 * @param {Boolean} afterMove  La carte est en train de bouger : attendre qu'elle s'arrête pour recadrer
		 */
		openPopup: function(resellers, latLng, afterMove) {
			var self = this;
			var $content = $('<div class="resellers-popup__items"></div>');

			resellers.forEach(function(reseller) {
				var $body = reseller.$item.find('.resellers-item__body').clone();
				// Dans l'infobulle, le nom n'est plus un bouton
				$body.find('[data-reseller-show]').each(function() {
					$(this).replaceWith(document.createTextNode($(this).text()));
				});
				$('<div class="resellers-popup__item"></div>').append($body.children()).appendTo($content);
			});

			var $close = $('<button type="button" class="resellers-popup__close" aria-label="Fermer"></button>')
				.html(CLOSE_SVG)
				.on('click', function() {
					self.closePopup();
				});

			self.popup.show(self.map, latLng, $close.add($content));

			// Une fois l'infobulle placée, on décale la carte si elle dépasse
			var keepVisible = function() {
				self.keepPopupVisible();
			};
			if (afterMove) {
				self.maps.event.addListenerOnce(self.map, 'idle', keepVisible);
			} else {
				window.setTimeout(keepVisible, 60);
			}
		},

		closePopup: function() {
			if (this.popup) this.popup.hide();
			this.setActive(null);
		},

		keepPopupVisible: function() {
			if (!this.popup || !this.popup.isOpen()) return;

			var margin = 20;
			var mapRect = this.mapEl.getBoundingClientRect();
			var rect = this.popup.div.getBoundingClientRect();
			var dx = 0;
			var dy = 0;

			if (rect.right > mapRect.right - margin) dx = rect.right - (mapRect.right - margin);
			if (rect.left - dx < mapRect.left + margin) dx = rect.left - (mapRect.left + margin);
			if (rect.bottom > mapRect.bottom - margin) dy = rect.bottom - (mapRect.bottom - margin);
			if (rect.top - dy < mapRect.top + margin) dy = rect.top - (mapRect.top + margin);

			if (dx || dy) this.map.panBy(dx, dy);
		},

		/**
		 * Sur mobile, la carte est au-dessus de la liste : on remonte jusqu'à elle
		 */
		bringMapIntoView: function() {
			var header = $('#header').outerHeight() || 0;
			var rect = this.mapEl.getBoundingClientRect();

			if (rect.top < header) {
				$('html, body').animate({ scrollTop: $(this.mapEl).offset().top - header - 10 }, 300);
			}
		},

		/* ================================
		 * Liste
		 * ================================ */
		bindList: function() {
			var self = this;

			self.$list.on('click', '[data-reseller-show]', function() {
				var reseller = self.byId[$(this).closest('[data-reseller]').attr('data-id')];
				if (reseller) self.select(reseller, { fromList: true });
			});

			$(document).on('keydown', function(event) {
				if ((event.key === 'Escape' || event.key === 'Esc') && self.popup && self.popup.isOpen()) {
					self.closePopup();
				}
			});
		},

		/**
		 * Affiche ces revendeurs, dans cet ordre, et masque les autres
		 */
		showList: function(resellers) {
			var fragment = document.createDocumentFragment();

			this.resellers.forEach(function(reseller) {
				reseller.$item.addClass('is-hidden');
			});
			resellers.forEach(function(reseller) {
				reseller.$item.removeClass('is-hidden');
				fragment.appendChild(reseller.$item[0]);
			});

			this.$list[0].appendChild(fragment);
			this.$list.scrollTop(0);
		},

		scrollListTo: function($item) {
			if ($item.hasClass('is-hidden')) return;
			this.$list.stop().animate({ scrollTop: $item[0].offsetTop - 10 }, 300);
		},

		/* ================================
		 * Recherche
		 * ================================ */
		bindSearch: function() {
			var self = this;

			self.$form.on('submit', function(event) {
				event.preventDefault();
				self.closeSuggestions();

				var query = self.$input.val().trim();
				if (query) {
					self.geocode(query);
				} else {
					self.reset();
				}
			});

			self.$locate.on('click', function() {
				self.locate();
			});

			self.$input.on('input', function() {
				var query = self.$input.val().trim();
				window.clearTimeout(self.suggest.timer);

				if (!self.suggest.enabled || query.length < 3) {
					self.closeSuggestions();
					return;
				}
				self.suggest.timer = window.setTimeout(function() {
					self.fetchSuggestions(query);
				}, 250);
			});

			self.$input.on('keydown', function(event) {
				var count = self.suggest.items.length;
				if (!count) return;

				if (event.key === 'ArrowDown' || event.key === 'Down') {
					event.preventDefault();
					self.highlightSuggestion((self.suggest.active + 1) % count);
				} else if (event.key === 'ArrowUp' || event.key === 'Up') {
					event.preventDefault();
					self.highlightSuggestion((self.suggest.active - 1 + count) % count);
				} else if (event.key === 'Enter' && self.suggest.active >= 0) {
					event.preventDefault();
					self.chooseSuggestion(self.suggest.active);
				} else if (event.key === 'Escape' || event.key === 'Esc') {
					self.closeSuggestions();
				}
			});

			self.$input.on('blur', function() {
				window.setTimeout(function() {
					self.closeSuggestions();
				}, 150);
			});

			// mousedown plutôt que click : il passe avant la perte du focus
			self.$suggestions.on('mousedown', '[data-index]', function(event) {
				event.preventDefault();
				self.chooseSuggestion(parseInt($(this).attr('data-index'), 10));
			});
		},

		/**
		 * Revendeurs proches d'un point, du plus proche au plus éloigné
		 *
		 * @param {Object} point  { lat, lng }
		 * @param {String} label  Ce qui a été cherché, pour le message
		 */
		searchAround: function(point, label) {
			var settings = this.settings;
			var sorted = this.resellers
				.map(function(reseller) {
					return { reseller: reseller, distance: distanceKm(point, reseller) };
				})
				.sort(function(a, b) {
					return a.distance - b.distance;
				});
			var nearby = sorted.filter(function(entry) {
				return entry.distance <= settings.radius;
			});
			var results = (nearby.length ? nearby : sorted.slice(0, settings.fallback)).map(function(entry) {
				return entry.reseller;
			});

			this.closePopup();
			this.showList(results);

			if (nearby.length) {
				this.setStatus(plural(nearby.length, 'revendeur') + ' à moins de ' + settings.radius + ' km de ' + label + '.');
			} else if (results.length) {
				this.setStatus(
					'Aucun revendeur à moins de ' + settings.radius + ' km de ' + label + '. ' +
					(results.length > 1 ? 'Voici les ' + results.length + ' plus proches.' : 'Voici le plus proche.')
				);
			} else {
				this.setStatus('Aucun revendeur à moins de ' + settings.radius + ' km de ' + label + '.');
			}

			if (this.map) {
				var latLng = new this.maps.LatLng(point.lat, point.lng);
				this.position.show(this.map, latLng);
				this.fitTo(results, latLng);
			}
		},

		/**
		 * Recherche dans le texte des fiches (nom, adresse, code postal, ville),
		 * quand l'adresse n'a pas pu être localisée
		 *
		 * @return {Boolean} Vrai si au moins un revendeur correspond
		 */
		searchByText: function(query) {
			var needle = normalize(query);
			var results = this.resellers.filter(function(reseller) {
				return reseller.text.indexOf(needle) !== -1;
			});

			if (!results.length) return false;

			this.closePopup();
			if (this.position) this.position.hide();
			this.showList(results);
			this.setStatus(plural(results.length, 'revendeur') + ' pour « ' + query + ' ».');
			this.fitTo(results);
			return true;
		},

		geocode: function(query) {
			var self = this;

			if (!self.map) {
				if (!self.searchByText(query)) self.notFound();
				return;
			}

			var request = new self.maps.Geocoder().geocode({ address: query, region: 'fr' }, function(results, status) {
				if (status === 'OK' && results.length) {
					var location = results[0].geometry.location;
					self.searchAround({ lat: location.lat(), lng: location.lng() }, '« ' + query + ' »');
				} else if (!self.searchByText(query)) {
					self.notFound();
				}
			});

			// Les versions récentes renvoient aussi une promesse, rejetée en cas d'erreur
			if (request && typeof request.then === 'function') {
				request.then(null, function() {});
			}
		},

		notFound: function() {
			this.setStatus('Adresse introuvable. Vérifiez votre saisie ou indiquez un code postal.');
		},

		locate: function() {
			var self = this;

			if (!navigator.geolocation) {
				self.setStatus('La géolocalisation n\'est pas disponible sur ce navigateur. Saisissez une adresse.');
				return;
			}

			self.$locate.attr('aria-busy', 'true').prop('disabled', true);
			self.setStatus('Recherche de votre position…');

			navigator.geolocation.getCurrentPosition(
				function(position) {
					self.$locate.removeAttr('aria-busy').prop('disabled', false);
					self.$input.val('');
					self.searchAround({ lat: position.coords.latitude, lng: position.coords.longitude }, 'votre position');
				},
				function() {
					self.$locate.removeAttr('aria-busy').prop('disabled', false);
					self.setStatus('Votre position n\'a pas pu être obtenue. Vérifiez que la localisation est autorisée, ou saisissez une adresse.');
				},
				{ enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
			);
		},

		reset: function() {
			this.closePopup();
			if (this.position) this.position.hide();
			this.showList(this.resellers);
			this.setStatus('');
			this.fitTo(this.resellers);
		},

		setStatus: function(message) {
			this.$status.text(message || '');
		},

		/* ================================
		 * Suggestions d'adresses (Places API New)
		 * ================================ */
		fetchSuggestions: function(query) {
			var self = this;
			var places = self.maps.places;
			var request = ++self.suggest.request;

			if (!self.suggest.token) self.suggest.token = new places.AutocompleteSessionToken();

			places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
				input: query,
				includedRegionCodes: REGIONS,
				language: 'fr',
				region: 'fr',
				sessionToken: self.suggest.token,
			}).then(
				function(response) {
					if (request !== self.suggest.request) return;
					self.renderSuggestions(
						response.suggestions
							.filter(function(suggestion) {
								return suggestion.placePrediction;
							})
							.slice(0, 5)
					);
				},
				function() {
					// Places API (New) indisponible pour cette clé : la recherche reste possible en validant
					self.suggest.enabled = false;
					self.closeSuggestions();
				}
			);
		},

		renderSuggestions: function(suggestions) {
			var self = this;

			self.suggest.items = suggestions;
			self.suggest.active = -1;
			self.$suggestions.empty();

			if (!suggestions.length) {
				self.closeSuggestions();
				return;
			}

			suggestions.forEach(function(suggestion, index) {
				$('<li class="resellers-search__suggestion" role="option" aria-selected="false"></li>')
					.attr({ id: 'resellers-suggestion-' + index, 'data-index': index })
					.text(suggestion.placePrediction.text.toString())
					.appendTo(self.$suggestions);
			});

			self.$suggestions.prop('hidden', false);
			self.$input.attr('aria-expanded', 'true');
		},

		highlightSuggestion: function(index) {
			this.suggest.active = index;
			this.$suggestions
				.children()
				.removeClass('is-active')
				.attr('aria-selected', 'false')
				.eq(index)
				.addClass('is-active')
				.attr('aria-selected', 'true');
			this.$input.attr('aria-activedescendant', 'resellers-suggestion-' + index);
		},

		closeSuggestions: function() {
			this.suggest.items = [];
			this.suggest.active = -1;
			this.$suggestions.prop('hidden', true).empty();
			this.$input.attr('aria-expanded', 'false').removeAttr('aria-activedescendant');
		},

		chooseSuggestion: function(index) {
			var self = this;
			var suggestion = self.suggest.items[index];
			if (!suggestion) return;

			var text = suggestion.placePrediction.text.toString();
			var place = suggestion.placePrediction.toPlace();

			self.$input.val(text);
			self.closeSuggestions();
			// La session de suggestions se termine avec la demande de détails
			self.suggest.token = null;

			place.fetchFields({ fields: ['location'] }).then(
				function() {
					if (place.location) {
						self.searchAround({ lat: place.location.lat(), lng: place.location.lng() }, '« ' + text + ' »');
					} else {
						self.geocode(text);
					}
				},
				function() {
					self.geocode(text);
				}
			);
		},
	};

	/* ================================
	 * Calques HTML sur la carte
	 * ================================ */

	/**
	 * Marqueurs et regroupements. Les revendeurs proches à l'écran sont
	 * regroupés, et le regroupement est recalculé quand l'échelle change.
	 */
	function createMarkersLayer(maps, finder) {
		function MarkersLayer() {
			this.div = null;
			this.groups = [];
			this.scale = null;
		}

		MarkersLayer.prototype = new maps.OverlayView();

		MarkersLayer.prototype.onAdd = function() {
			var layer = this;

			layer.div = document.createElement('div');
			// La liste offre les mêmes actions au clavier et aux lecteurs d'écran
			layer.div.setAttribute('aria-hidden', 'true');
			layer.getPanes().overlayMouseTarget.appendChild(layer.div);

			if (maps.OverlayView.preventMapHitsAndGesturesFrom) {
				maps.OverlayView.preventMapHitsAndGesturesFrom(layer.div);
			}

			$(layer.div).on('click', '[data-group]', function(event) {
				event.stopPropagation();
				finder.onGroupClick(layer.groups[parseInt($(this).attr('data-group'), 10)]);
			});
		};

		MarkersLayer.prototype.onRemove = function() {
			$(this.div).remove();
			this.div = null;
		};

		MarkersLayer.prototype.draw = function() {
			var projection = this.getProjection();
			if (!projection || !this.div) return;

			// Pendant une animation de zoom, getZoom() donne déjà le zoom d'arrivée alors que
			// la projection est encore à l'ancien : on regroupe d'après la projection elle-même
			var scale = projection.getWorldWidth();
			if (scale !== this.scale) {
				this.scale = scale;
				this.groups = cluster(maps, projection, finder.resellers);
				this.render();
			}

			var markers = this.div.children;
			for (var i = 0; i < markers.length; i++) {
				var point = projection.fromLatLngToDivPixel(this.groups[i].latLng);
				markers[i].style.left = point.x + 'px';
				markers[i].style.top = point.y + 'px';
			}
		};

		MarkersLayer.prototype.render = function() {
			this.div.innerHTML = this.groups
				.map(function(group, index) {
					var count = group.resellers.length;
					if (count === 1) {
						return '<button type="button" tabindex="-1" class="resellers-marker" data-group="' + index + '" data-id="' + group.resellers[0].id + '">' + PIN_SVG + '</button>';
					}
					return '<button type="button" tabindex="-1" class="resellers-marker resellers-marker--cluster" data-group="' + index + '">' + PIN_SVG + '<span class="resellers-marker__count">' + count + '</span></button>';
				})
				.join('');
			this.markActive();
		};

		MarkersLayer.prototype.markActive = function() {
			if (!this.div) return;
			$(this.div).find('.is-active').removeClass('is-active');
			if (finder.activeId) {
				$(this.div).find('[data-id="' + finder.activeId + '"]').addClass('is-active');
			}
		};

		return new MarkersLayer();
	}

	/**
	 * Regroupe les revendeurs dont les marqueurs se chevaucheraient
	 */
	function cluster(maps, projection, resellers) {
		var points = resellers.map(function(reseller) {
			var pixel = projection.fromLatLngToDivPixel(reseller.latLng);
			return { reseller: reseller, x: pixel.x, y: pixel.y };
		});
		var taken = [];
		var groups = [];

		for (var i = 0; i < points.length; i++) {
			if (taken[i]) continue;

			var members = [points[i].reseller];
			var lat = points[i].reseller.lat;
			var lng = points[i].reseller.lng;
			taken[i] = true;

			for (var j = i + 1; j < points.length; j++) {
				if (!taken[j] && Math.abs(points[j].x - points[i].x) <= CLUSTER_DISTANCE && Math.abs(points[j].y - points[i].y) <= CLUSTER_DISTANCE) {
					taken[j] = true;
					members.push(points[j].reseller);
					lat += points[j].reseller.lat;
					lng += points[j].reseller.lng;
				}
			}

			groups.push({
				resellers: members,
				latLng: new maps.LatLng(lat / members.length, lng / members.length),
			});
		}

		return groups;
	}

	/**
	 * Élément HTML ancré à un point de la carte (infobulle, position recherchée)
	 */
	function createHtmlOverlay(maps, className, pane) {
		function HtmlOverlay() {
			this.div = document.createElement('div');
			this.div.className = className;
			this.latLng = null;
		}

		HtmlOverlay.prototype = new maps.OverlayView();

		HtmlOverlay.prototype.onAdd = function() {
			this.getPanes()[pane].appendChild(this.div);
			if (pane === 'floatPane' && maps.OverlayView.preventMapHitsAndGesturesFrom) {
				maps.OverlayView.preventMapHitsAndGesturesFrom(this.div);
			}
		};

		HtmlOverlay.prototype.onRemove = function() {
			if (this.div.parentNode) this.div.parentNode.removeChild(this.div);
		};

		HtmlOverlay.prototype.draw = function() {
			var projection = this.getProjection();
			if (!projection || !this.latLng) return;
			var point = projection.fromLatLngToDivPixel(this.latLng);
			this.div.style.left = point.x + 'px';
			this.div.style.top = point.y + 'px';
		};

		HtmlOverlay.prototype.show = function(map, latLng, content) {
			this.latLng = latLng;
			if (content) $(this.div).empty().append(content);
			if (this.getMap()) {
				this.draw();
			} else {
				this.setMap(map);
			}
		};

		HtmlOverlay.prototype.hide = function() {
			this.setMap(null);
		};

		HtmlOverlay.prototype.isOpen = function() {
			return !!this.getMap();
		};

		return new HtmlOverlay();
	}

	/* ================================
	 * Utilitaires
	 * ================================ */

	/**
	 * Charge l'API Google Maps une seule fois
	 *
	 * @return {Promise} Résolue avec google.maps
	 */
	function loadMaps(key) {
		var deferred = $.Deferred();

		if (window.google && window.google.maps && window.google.maps.Map) {
			return deferred.resolve(window.google.maps).promise();
		}
		if (!key) {
			return deferred.reject().promise();
		}

		window[MAPS_CALLBACK] = function() {
			deferred.resolve(window.google.maps);
		};
		// Clé refusée par Google (clé invalide, domaine non autorisé)
		window.gm_authFailure = function() {
			deferred.reject();
		};

		var script = document.createElement('script');
		script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&language=fr&region=FR&loading=async&callback=' + MAPS_CALLBACK;
		script.async = true;
		script.onerror = function() {
			deferred.reject();
		};
		document.head.appendChild(script);

		return deferred.promise();
	}

	function distanceKm(a, b) {
		var radians = Math.PI / 180;
		var dLat = (b.lat - a.lat) * radians;
		var dLng = (b.lng - a.lng) * radians;
		var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * radians) * Math.cos(b.lat * radians) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
		return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
	}

	/**
	 * Minuscules, sans accents ni espaces superflus, pour comparer des textes
	 */
	function normalize(text) {
		var value = String(text).toLowerCase();
		if (value.normalize) value = value.normalize('NFD').replace(/[̀-ͯ]/g, '');
		return value.replace(/\s+/g, ' ').trim();
	}

	function plural(count, word) {
		return count + ' ' + word + (count > 1 ? 's' : '');
	}

	$(function() {
		var $root = $('[data-resellers]');
		if ($root.length) {
			window.AZURLIGN_RESELLERS = new ResellersFinder($root.first());
		}
	});
})(jQuery, window, document);
